export default __webpack_public_path__ + "static/media/instagram-filled.0569f6bd.svg";